"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Get the response initial state from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questionnaire
 * @returns {{
 *    answers: { id: string, isMandatory: boolean, answer: any }[]
 * }}
 */
var getFeedbackResponseInitialState = function getFeedbackResponseInitialState(questionnaire) {
  var answers = questionnaire.map(function (_ref) {
    var questionId = _ref.questionId,
      isMandatory = _ref.isMandatory;
    return {
      id: questionId,
      isMandatory: isMandatory,
      answer: null
    };
  });
  return {
    answers: answers
  };
};
var _default = exports["default"] = getFeedbackResponseInitialState;
//# sourceMappingURL=getFeedbackResponseInitialState.js.map